import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomNetworkUtils } from '../../ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { EcomCookies } from '../../ecom-services/ecom-cookies';

@Component({
  selector: 'app-ecom-vouchers',
  templateUrl: './ecom-vouchers.component.html',
  styleUrls: ['./ecom-vouchers.component.scss']
})
export class EcomVouchersComponent implements OnInit {

  currentVouchers = [];
  pastVouchers = [];
  newVouchers = [];
  myvouchers = true;
  browsevouchers = false;
  currency = 'MYR';
  qrCodeScanned = false;
  constructor(private eComGoogleAnalytics:EComGoogleAnalytics,public router: Router, public ecomservice: EComService,
    public webstorage: EComWebStorage, private cookie: EcomCookies) { }

  ngOnInit() {
    let gTag = {
      'event':'screen_view',
      'screen_name':'my vouchers'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    if(!this.webstorage.sessionSt_is_session_valid){
      this.router.navigate(['home']);
    }
    if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true)) {
      this.qrCodeScanned = this.webstorage.sessionSt_qr_code_scanned;
    }
    this.getVoucherList();
    this.currency = this.ecomservice.GetCountryCurrency(this.cookie.cookie_country_code);
  }


  getVoucherList() {
    const input = {
      oocv_ooc_guid: this.webstorage.localSt_user_id,
      user_country_code: this.cookie.cookie_country_code
    };

    this.ecomservice.httpPost(EcomNetworkUtils.POST_VOUCHERSLIST, input, '', true).subscribe((response) => {
      if (response.isSuccess) {
        // current vouchers
        for (let i = 0; i < response.listValue.ListCurrentVoucher.length; i++) {
          this.currentVouchers.push(response.listValue.ListCurrentVoucher[i]);
        }

        // past vouchers
        for (let i = 0; i < response.listValue.ListPastVoucher.length; i++) {
          this.pastVouchers.push(response.listValue.ListPastVoucher[i]);
        }

        //new vouchers
        for (let i = 0; i < response.listValue.ListNewVouchers.length; i++) {
          this.newVouchers.push(response.listValue.ListNewVouchers[i]);
          this.newVouchers[i].message = '';
        }
      }
    });
  }

  // Method to handle the ordertype tab click event
  onTypeClick(type) {
    if (type === 'BROWSE') {
      this.myvouchers = false;
      this.browsevouchers = true;
    } else {
      this.myvouchers = true;
      this.browsevouchers = false;
    }
  }

  onClaimClick(index, voucher) {
    const input = {
      oocv_mod_guid: this.newVouchers[index].ModGuid,
      oocv_ooc_guid: this.webstorage.localSt_user_id,
      oocv_code: voucher.VoucherName,
      oocv_amount: voucher.VoucherAmount
    };
    this.ecomservice.httpPost(EcomNetworkUtils.POST_VOUCHERCLAIM, input, '', true).subscribe((response) => {
      this.newVouchers[index].message = response.msg;
    });
  }

  onOrderNowClick(){
    this.router.navigate(['stores']);
  }

}
